import { render, staticRenderFns } from "./LiveAuctionComponent.vue?vue&type=template&id=6decaae2"
import script from "./LiveAuctionComponent.vue?vue&type=script&lang=js"
export * from "./LiveAuctionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports